<template>
  <CustomRow>
    <v-card height="574" class="mt-5 text-center cusPadding">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10" sm="8" md="6">
          <v-img src="@/assets/image/images-mail@3x.png" :width="imageWidth" class="mx-auto mb-8"></v-img>
          <div class="text-center text-title font-weight-bold" v-html="$t('has_send_pwd_content', { email: email })">
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10" sm="6" md="4">
          <v-btn color="primary" outlined depressed block x-large class="mt-8 font-weight-bold rounded-lg"
            style="border: 3px solid" :disabled="!loadingFinished" @click="sendVerify">
            <template v-if="!loadingFinished">
              <v-progress-circular indeterminate color="grey" size="25" width="2"></v-progress-circular>
            </template>
            <template v-else>
              {{ $t("has_send_pwd_resend_cta") }}
            </template>
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
  </CustomRow>
</template>

<script>
import UM from "@/api/user-management";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loadingFinished: true
    };
  },
  computed: {
    countryCode() {
      return this.$route.params.countryCode || "";
    },
    mobile() {
      return this.$route.params.mobile || "";
    },
    email() {
      return this.$route.params.email || "";
    },
    imageWidth() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        return "100";
      else return "120";
    }
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show"
    }),
    async sendVerify() {
      this.loadingFinished = false;
      if (this.mobile && this.email) {
        const { data } = await UM.sendForgetPassword(this.countryCode, this.mobile, this.email);
        if (data.errCode !== "00")
          console.log(`${data.errCode}\n${data.errMsg}\n${data.errDetail}`);
        if (data.errCode == "00")
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-success@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('has_send_pwd_send_success')}</div>
          </div>`
          });
        else
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('has_send_pwd_send_fail')}<br>${data.errDetail}</div>
          </div>`
          });
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('pwd_link_error')}</div>
          </div>`
        });
        setTimeout(() => {
          this.$router.push({ name: "Index" }).catch(() => { });
        }, 2000);
      }
      this.loadingFinished = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 100px 20px;
}
</style>
